import { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'
// const isDev = process.env.NODE_ENV === 'development'
const useIsLogin = () => {
  // const [mounted, setMounted] = useState(false)
  const [cookies, setCookie, removeCookie] = useCookies()
  // useEffect(() => {
  //   setMounted(true)
  //   console.log(!!cookies.token)
  // }, [cookies])
  // const cookie = new Cookies();
  const isLoggedIn = !!cookies.token
  return isLoggedIn
}
export default useIsLogin
